import { gql } from "@apollo/client";

// Compliance documents (see wfc-server service/complianceService). Every response is
// { message, response } with response as JSON.

export const getComplianceDocumentsQuery = gql`
    query getComplianceDocuments($filter: ComplianceDocumentFilter){
        getComplianceDocuments(filter: $filter){
            message
            response
        }
    }
`;

export const getComplianceOverviewQuery = gql`
    query getComplianceOverview{
        getComplianceOverview{
            message
            response
        }
    }
`;

export const getDocumentRecipientsQuery = gql`
    query getDocumentRecipients($documentId: String!){
        getDocumentRecipients(documentId: $documentId){
            message
            response
        }
    }
`;

export const getDocumentVersionsQuery = gql`
    query getDocumentVersions($documentId: String!){
        getDocumentVersions(documentId: $documentId){
            message
            response
        }
    }
`;

export const getEmployeeAcknowledgementsQuery = gql`
    query getEmployeeAcknowledgements($employeeId: String!){
        getEmployeeAcknowledgements(employeeId: $employeeId){
            message
            response
        }
    }
`;

export const getSignedCopyUrlQuery = gql`
    query getSignedCopyUrl($shareId: String!){
        getSignedCopyUrl(shareId: $shareId){
            message
            response
        }
    }
`;

export const getComplianceSettingsQuery = gql`
    query getComplianceSettings{
        getComplianceSettings{
            message
            response
        }
    }
`;

// the field editor's view of a document: its pages, fields placed, or its own fillable fields
export const getDocumentFormSetupQuery = gql`
    query getDocumentFormSetup($documentId: String!){
        getDocumentFormSetup(documentId: $documentId){
            message
            response
        }
    }
`;

// an officer's document with fields (the app's web view page)
export const getComplianceDocumentFormQuery = gql`
    query getComplianceDocumentForm($shareId: String!){
        getComplianceDocumentForm(shareId: $shareId){
            message
            response
        }
    }
`;
